<div class="input-wrapper" pcLabelUpInputAnimation [alwaysTop]="inputPlaceholder !== ''">
  <div
    class="input-border"
    [ngClass]="{ focus: isInputFocus, required: InputError && InputError.error, sales: isSalesInput }"
    [style.background-color]="inputBackgroundColor"
  >
    <label
      #labelUpDirective
      class="input-label"
      [for]="cid"
      [ngClass]="{
        sales: isSalesInput,
        static: inputPlaceholder !== '',
        'mandatory-before': isMandatory && asteriskPosition === 'before',
        'mandatory-after': isMandatory && asteriskPosition === 'after'
      }"
    >
      {{ placeholder ? (placeholder | translate) : '' }}
    </label>
    <div class="input-and-icon">
      <input
        #inputElement
        #textDirective
        class="pc-input"
        pcNumbersOnly
        [allowDecimal]="allowDecimal"
        [appNumbersOnly]="onlyNumbers"
        [attr.autocomplete]="enableAutocomplete() ? 'on' : 'disabled'"
        [attr.inputmode]="onlyNumbers ? 'numeric' : null"
        [disabled]="disable() || isLoading()"
        [id]="cid"
        [isAmountInput]="isAmountInput"
        [maxLength]="maxLimit"
        [name]="name"
        [ngClass]="{ sales: isSalesInput, 'with-label': placeholder !== '', capitalize: isCapitalized }"
        [placeholder]="inputPlaceholder"
        [tabIndex]="tabIndex"
        [type]="type"
        (blur)="onInputBlur()"
        (focus)="onInputFocus()"
        (paste)="onInputPaste($event)"
        [(ngModel)]="value"
      />
      @if (isLoading()) {
        <pc-spinning-loader class="spinning-loader" [isPrimaryColor]="true"></pc-spinning-loader>
      }
      <img
        *ngIf="inputButtonType !== InputButtonType.NO_BTN"
        class="input-icon"
        src="{{ getIconSrc() }}"
        alt=""
        tabindex="0"
        (click)="onClearText()"
        (keydown.enter)="onClearText()"
      />
    </div>
  </div>

  <span
    class="error-text"
    aria-atomic="true"
    [attr.aria-live]="applyAlert() ? 'assertive' : null"
    [attr.role]="InputError?.error && isInputFocus && applyAlert() ? 'alert' : null"
    [class.ltr-inline]="isSalesInput && businessUnit() === BusinessUnit.AU"
  >
    {{ InputError?.error ?? '' | translate }}
  </span>
</div>
